export default __webpack_public_path__ + "static/media/temp stay E6 - work training.76908e13.jpg";